import { Component, OnInit } from '@angular/core';
import {UtilService} from '../../services/utilService/util.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {SuperAdminService} from '../../services/apiCalls/superAdminService/super-admin.service';
import {UserService} from '../../services/apiCalls/userService/user.service';
import { environment as ENV } from '../../../environments/environment';
import {IResponse} from '../../interfaces/iresponse';
@Component({
  selector: 'app-commision-sharing',
  templateUrl: './commision-sharing.component.html',
  styleUrls: ['./commision-sharing.component.css']
})
export class CommisionSharingComponent implements OnInit {
  breadCrumb: any;
  showData = true;
  public beneficiaries: any[] = [];
  public sharingFormulas: any[] = [];
  loadingData = false;
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  loaders = {
    saving: false
  };
  modal = {
    title: 'Create Sharing Formula',
    btnText: 'Save'
  };
  activeSharingFormula = null;
  sharingFormula =  {
    first_name: null,
    last_name: null,
    middle_name: null
  };
  constructor(private utilService: UtilService,
              private bootstrapNotify: BootstrapNotifyService,
              private userService: UserService,
              private superAdminService: SuperAdminService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Commission Sharing',
      parent: 'Home',
      subLink: null
    };
    this.getSharingFormulas();
    this.getBeneficiary();
  }

  getSharingFormulas() {
    this.showData = false;
    this.loadingData = true;
    this.superAdminService.getSharingFormulas()
      .subscribe((res: IResponse) => {
        this.sharingFormulas = res.data;
        this.utilService.riderTable('all-sharing-formula', false);
        this.loadingData = false;
        this.showData = true;
      }, error => {
        this.utilService.startDatatable('all-sharing-formula');
        this.loadingData = false;
        this.showData = true;
      });
  }

  getBeneficiary() {
    this.superAdminService.getBeneficiaries()
      .subscribe((res: IResponse) => {
        this.beneficiaries = res.data;
      }, error => {
      });
  }


  openDialog(id) {
    this.modal = {
      title: 'Create Sharing Formula',
      btnText: 'Save'
    };
    this.activeSharingFormula = null;
    this.resetForm();
    this.utilService.openModal(id);
  }

  public deleteSharingFormula(shareFormula) {
    this.utilService.confirmAction(() => {
      this.superAdminService.deleteBeneficiary(shareFormula.id)
        .subscribe((res: IResponse) => {
          this.getSharingFormulas();
        }, error => {
        });
    });
  }
  public triggerEdit(sharingFormula) {
    this.activeSharingFormula = JSON.parse(JSON.stringify(sharingFormula));
    this.resetForm();
    this.utilService.openModal('createSharingFormula');
    this.sharingFormula = this.activeSharingFormula;
    this.modal = {
      title: 'Update Sharing Formula',
      btnText: 'Update'
    };
  }

  public resetForm() {
    this.sharingFormula =  {
      first_name: null,
      last_name: null,
      middle_name: null
    };
  }
  
  public createSharingFormula() {
    this.loaders.saving = true;
    this.checkError(this.sharingFormula, () => {
      if (this.activeSharingFormula) {
        this.updateSharingFormula();
      } else {
        this.superAdminService.createBeneficiary(this.sharingFormula).subscribe((response: IResponse) => {
          this.loaders.saving = false;
          this.resetForm();
          this.getSharingFormulas();
          this.utilService.closeModal('createSharingFormula');
          this.bootstrapNotify.success(response.message || 'Sharing formula created', 'right');
        }, error => {
          this.bootstrapNotify.error(error.error.message || 'Unable to create sharing formula!', 'right');
          this.loaders.saving = false;
        });
      }
    }, ['contact_address', 'middle_name']);
  }
  public checkError(data, cb, omit= []) {
    const keys = Object.keys(data);
    const resolvedKeys = keys.filter(d => !omit.includes(d));
    for (const key of resolvedKeys) {
      if (!data[key]) {
        this.loaders.saving = false;
        return this.bootstrapNotify.info(`${key.toString().toUpperCase().split('_').join(' ')} is Required`);
      }
    }
    cb();
  }
  public updateSharingFormula() {
    this.superAdminService.updateBeneficiary(this.sharingFormula, this.activeSharingFormula.id).subscribe((response: IResponse) => {
      this.loaders.saving = false;
      this.resetForm();
      this.getSharingFormulas();
      this.utilService.closeModal('createSharingFormula');
      this.bootstrapNotify.success(response.message || 'Sharing formula updated', 'right');
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update sharing formula!', 'right');
      this.loaders.saving = false;
    });
  }


}
